import { ReactComponent as Banner } from "../assets/graphics/michelle-illustration-banner.svg";
import { ReactComponent as Logo } from "../assets/graphics/michelle-logo.svg";
import "../styles/components/header.scss";

function Header() {
  return (
    <header className="header">
      <div className="header-container">
        <p className="info">
          Montréal photographer offering family sessions, wedding photography,
          engagement sessions, portraits, and commercial photography.
        </p>
        <Logo className="logo" />
        <p className="info-mobile">
          Offering family sessions, wedding photography, engagement sessions,
          portraits, and commercial photography.
        </p>
        <div className="contact-info">
          <p>
            <a href="mailto:michelleelizabethheppner@gmail.com">
              Email: michelleelizabethheppner@gmail.com
            </a>
          </p>
          <p>
            <a href="https://www.instagram.com/michelleeheppner/">
              Instagram: michelleeheppner
            </a>
          </p>
        </div>
      </div>
      <Banner className="header__banner" />
    </header>
  );
}

export default Header;
